var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("系统管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: {
                        content: _vm.categoryId == "" ? "新增分类" : "编辑分类",
                      },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "分类名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入分类名称" },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转地址", prop: "link" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入跳转地址" },
                          model: {
                            value: _vm.ruleForm.link,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "link", $$v)
                            },
                            expression: "ruleForm.link",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上级分类", prop: "pid" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            props: _vm.cateProps,
                            "show-all-levels": false,
                            options: _vm.list,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.selectData,
                            callback: function ($$v) {
                              _vm.selectData = $$v
                            },
                            expression: "selectData",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "归属", prop: "pageModule" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.ruleForm.pageModule,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "pageModule", $$v)
                              },
                              expression: "ruleForm.pageModule",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "首页(开屏广告)", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "文章分类", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "标签分类", value: "3" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序", prop: "sort" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入排序" },
                          model: {
                            value: _vm.ruleForm.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "sort", $$v)
                            },
                            expression: "ruleForm.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            staticStyle: { "margin-right": "auto" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }